// lingland-frontend/src/components/common/StatCounter.js (POPRAWIONA WERSJA)
import React from 'react';
import CountUp from 'react-countup';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import './StatCounter.css';

const StatCounter = ({ icon: Icon, end, suffix, duration = 2, label }) => {
    // Używamy hooka, aby wykryć, kiedy komponent staje się widoczny
    // Usunęliśmy triggerOnce, więc będzie się uruchamiał za każdym razem
    const [ref, isVisible] = useIntersectionObserver({
        threshold: 0.5,
    });

    return (
        <div className="stat-counter-item" ref={ref}>
            <div className="stat-icon-wrapper">
                {Icon && <Icon size={40} strokeWidth={1.5} />}
            </div>
            <div className="stat-content">
                <div className="stat-number">
                    {/* Uruchamiamy CountUp tylko wtedy, gdy element jest widoczny */}
                    {isVisible ? (
                        <CountUp
                            start={0}
                            end={end}
                            duration={duration}
                            separator=" "
                            suffix={suffix}
                        />
                    ) : (
                        `0${suffix || ''}`
                    )}
                </div>
                <div className="stat-label">{label}</div>
            </div>
        </div>
    );
};

export default StatCounter;